import React from 'react';
import { AppScreen } from '../data/screens';

/**
 * Device frame for real app screenshots.
 *
 * The frame is deliberately thin so the actual interface stays as large and
 * readable as possible — the screenshots are the persuasive content, not
 * decoration.
 */
export function PhoneFrame({
  screen,
  className = '',
  shadow = 'lg',
  decorative = false,
  eager = false
}: {
  screen: AppScreen;
  className?: string;
  shadow?: 'lg' | 'xl';
  decorative?: boolean;
  /** Set for above-the-fold screens so they are not lazy-loaded. */
  eager?: boolean;
}) {
  return <div className={`rounded-[2rem] bg-kitty-dark p-[6px] ${shadow === 'xl' ? 'shadow-[0_30px_70px_-20px_rgba(0,0,0,0.45)]' : 'shadow-[0_18px_45px_-15px_rgba(0,0,0,0.3)]'} ${className}`} data-id="element-243" data-mp="2gknr4zsbwxck">
      <div className="overflow-hidden rounded-[1.65rem] bg-white" data-id="element-244" data-mp="m7fown20xjgw">
        <img src={screen.src} alt={decorative ? '' : screen.alt} aria-hidden={decorative || undefined} loading={eager ? 'eager' : 'lazy'} decoding="async" className="block w-full" data-id="element-245" data-mp="r5pl90zhiq43" />
      </div>
    </div>;
}